export const Avatars = [
    "mdi-earth",
    "mdi-rocket",
    "mdi-death-star",
    "mdi-death-star-variant",
    "mdi-brain",
    "mdi-atom",
    "mdi-alien",
    "mdi-telescope",
    "mdi-flask",
    "mdi-space-station",
    "mdi-skull-crossbones",
    "mdi-virus",
    "mdi-bacteria",
    "mdi-weather-night",
    "mdi-white-balance-sunny",
    "mdi-brightness-2",
    "mdi-star-face",
    "mdi-bug",
    "mdi-space-invaders",
    "mdi-jellyfish",
    "mdi-spider-web",
    "mdi-cat",
    "mdi-robot",
    "mdi-ghost"
];